import type { AppConfigDto } from '@/types/webapi';

export const IConfigServiceId = Symbol.for('IConfigService');

export interface IConfigService {
    getConfig(): Promise<AppConfigDto>;
}
